/**
 * @module
 * @author Bayu Dwiyan Satria
 * @since 1.0.0
 */

/**
 * Utilities
 */
import { readEnv } from '@bayudwiyansatria/vue'

/**
 * Normalised runtime environment.
 *
 * @remarks
 * The single place `import.meta.env` is read. `readEnv` handles what comes back: an empty variable
 * — which a `.env` file produces the moment someone writes `VITE_API_BASE_URL=` — is truthy and
 * would silently become the base URL, and a trailing slash yields `//health` once a path is
 * appended.
 *
 * The reading happens here rather than in the package because `import.meta.env` is Vite's, and a
 * published library that reached for it would bind itself to one bundler.
 *
 * @example
 * ```ts
 * import { coreEnv } from '@/core/env'
 *
 * fetch(`${coreEnv.apiBaseUrl}/health`)
 * ```
 */
export const coreEnv = {
  /** Base path for API requests, without a trailing slash. */
  apiBaseUrl: readEnv(import.meta.env.VITE_API_BASE_URL, '/api/v1', { stripTrailingSlash: true })
}
